export enum productCategories {
    ProfessionalServices = 'Professional Services',
    Merchandise = 'Merchandise',
    CashAdvance = 'Cash Advance',
    Transportation = 'Transportation',
    AdditionalItems = 'Additional Items',
    TravelProtection = 'Travel Protection',
}
